import ReactLocalization from 'react-localization';
import en from '../../assets/strings/en.json';

const locale = new ReactLocalization({
  en
});

export default locale;
